import { render, staticRenderFns } from "./BodyHeader.vue?vue&type=template&id=3403ae6c&scoped=true&"
import script from "./BodyHeader.vue?vue&type=script&lang=ts&"
export * from "./BodyHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BodyHeader.vue?vue&type=style&index=0&id=3403ae6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403ae6c",
  null
  
)

export default component.exports